export {
  useApproveBySellerMutation,
  useCreateRentMutation,
  useGetRentInfoQuery,
  useGetRentPriceMutation,
  useRentsArriveBackToSellerMutation,
  useRentsArriveToBuyerMutation,
  useRentsCancelBySellerMutation,
  useRentsGenerateQrCodeMutation,
  useRentsGetRentsListQuery,
  useRentsSendBackToSellerMutation,
  useRentsValidateQrCodeMutation,
  useSendToBuyerMutation,
} from './queries'
